import { useEmbedContext } from 'src/shared/providers/Embed';

/**
 * Whether the application is in an embedded context (in an iframe)
 *
 * It returns true if query string isEmbed equals true. Once the value becomes
 * true, it remains true regardless if the isEmbed query param is removed. A
 * page refresh will reset the value based on the presence of the isEmbed query
 * string.
 */
export const useIsEmbed = () => useEmbedContext().isEmbed;
